(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
const footerMedia = window.matchMedia('(min-width: 761px)');
const syncFooter = () => document.querySelectorAll('[data-footer-disclosure]').forEach(item => { item.open = footerMedia.matches; });
syncFooter();
footerMedia.addEventListener('change', syncFooter);

  } catch(e) { console.error(e); }
})();
})();
